<template>
  <UIDialogActions
    :is-open
    :z-index
    title="Warning of changes"
    size="md"
    :actions
    @close="handleClose"
  >
    <UICheckbox
      v-if="oldType !== newType"
      v-model="modelValue.type"
    >
      <span class="asset-security-master-dialog__text">Change type from</span>
      {{ oldType }}
      <span class="asset-security-master-dialog__text">to</span>
      {{ newType }}
    </UICheckbox>
    <UICheckbox
      v-if="oldName !== newName"
      v-model="modelValue.name"
    >
      <span class="asset-security-master-dialog__text">Change name from</span>
      {{ oldName }}
      <span class="asset-security-master-dialog__text">to</span>
      {{ newName }}
    </UICheckbox>
    <UICheckbox
      v-if="oldTicker !== newTicker"
      v-model="modelValue.ticker"
    >
      <span class="asset-security-master-dialog__text">Change ticker from</span>
      {{ oldTicker }}
      <span class="asset-security-master-dialog__text">to</span>
      {{ newTicker }}
    </UICheckbox>
  </UIDialogActions>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

import { DialogActionsButton, ModalClass } from '@types'

import { UICheckbox } from '@ui/controllers'
import { UIDialogActions } from '@ui/modals'

type Props = {
  modal: ModalClass<any>
  oldType?: string
  oldName?: string
  oldTicker?: string
  newType?: string
  newName?: string
  newTicker?: string
}

type Emits = {
  save: []
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const modelValue = defineModel<{
  type: boolean,
  name: boolean,
  ticker: boolean,
}>({ required: true })

const isOpen = computed(() => props.modal.isOpened)
const zIndex = computed(() => props.modal.zIndex)

const actions = computed<DialogActionsButton[]>(() => [
  {
    label: 'Save',
    onClick: () => {
      handleClose()
      emit('save')
    },
    buttonVariant: 'primary',
  },
])

const handleClose = () => {
  props.modal.close()
}
</script>

<style>
.asset-security-master-dialog {
  &__text {
    @apply font-normal text-gray-400;
  }
}
</style>
